import React from 'react';

export default function Base(props) {
    return (
        <svg
            mlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={124.417}
            height={195.739}
            style={{
            }}
            viewBox="0 0 1355 2132"
            className={props.className}
        >
            <defs>
            <style>
                {`
                    #c-${props.id} .fil0 {fill:#${props.base}!important;fill-rule:nonzero!important}
                    #c-${props.id} .fil1 {fill:#252422!important;fill-rule:nonzero!important}
                `}
            </style>
            </defs>
            <g id={`c-${props.id}`}>
                <g>
                    <path className="fil0" d="M69 2029c84,10 346,39 606,39 336,0 546,-27 616,-38l0 -1351c-27,-33 -111,-148 -120,-306 -8,-128 9,-206 18,-244 -47,-16 -129,-43 -212,-58 -31,185 -157,317 -312,317 -156,0 -276,-126 -308,-314 -48,11 -92,26 -125,38 -16,6 -30,11 -41,14 -22,7 -34,10 -63,22 23,104 35,177 30,260 -10,142 -72,241 -93,271l5 1348zm836 -1931c-49,28 -131,57 -249,53 -107,-4 -183,-31 -230,-55 34,138 124,229 239,229 113,0 206,-93 241,-227z"/>
                    <path className="fil1" d="M69 2029c84,10 346,39 606,39 336,0 546,-27 616,-38l0 -1351c-27,-33 -111,-148 -120,-306 -8,-128 9,-206 18,-244 -47,-16 -129,-43 -212,-58 -31,185 -157,317 -312,317 -156,0 -276,-126 -308,-314 -48,11 -92,26 -125,38 -16,6 -30,11 -41,14 -22,7 -34,10 -63,22 23,104 35,177 30,260 -10,142 -72,241 -93,271l5 1348zm836 -1931c-49,28 -131,57 -249,53 -107,-4 -183,-31 -230,-55 34,138 124,229 239,229 113,0 206,-93 241,-227zm-556 -87l0 -3 17 -1c6,-1 12,-2 18,-3l15 -2 4 4 10 -1c0,3 0,6 1,9 16,12 97,68 245,74 179,6 256,-73 259,-76l1 -1c0,-2 0,-3 0,-5l4 0 5 -6 16 2c116,15 239,58 285,74l3 1c30,11 24,42 18,64 -8,35 -24,107 -17,228 10,161 111,276 112,277l8 9 0 12 0 1416 -26 5c-9,2 -231,43 -654,43 -317,0 -639,-42 -642,-43l-28 -4 -5 -1426 7 -9c1,-1 76,-98 86,-246 6,-82 -8,-152 -34,-268l-6 -26 24 -10c50,-22 66,-26 94,-35 11,-3 24,-8 39,-13 37,-13 85,-30 139,-42z"/>
                </g>
            </g>
        </svg>
    );
}
